import { render, staticRenderFns } from "./ConfirmBulkShipmentCommand.vue?vue&type=template&id=0f3e6862&"
import script from "./ConfirmBulkShipmentCommand.vue?vue&type=script&lang=ts&"
export * from "./ConfirmBulkShipmentCommand.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmBulkShipmentCommand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports